import { useLocation, useNavigate } from "react-router-dom";
import { useI18n } from "../i18n";
import { LANGUAGES } from "../i18n/languages";
import { isPublicPath, stripLang, withLang } from "../i18n/paths";
import Pic from "./pics";

// The language menu: a small "🌐 DE" pill that opens the phone's or
// browser's own list of languages.
export default function LanguagePicker({ className = "" }) {
  const { lang, setLang, t } = useI18n();
  const navigate = useNavigate();
  const { pathname, search, hash } = useLocation();

  const change = async (code) => {
    await setLang(code);
    const base = stripLang(pathname);
    if (isPublicPath(base)) navigate(withLang(code, base) + search + hash, { replace: true });
  };

  return (
    <label className={`lang-picker ${className}`} title={t("Language")}>
      <span className="lang-picker-face" aria-hidden>
        <Pic name="globe" /> <b>{lang.toUpperCase()}</b>
      </span>
      <select value={lang} onChange={(e) => change(e.target.value)} aria-label={t("Language")}>
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code} lang={l.code}>
            {l.name}
          </option>
        ))}
      </select>
    </label>
  );
}
